import axios from "axios";
import { Email } from "../models/email";

export const CONTACTO_URL = `Contacto`;

export const contactoServices = {
  send: function (data: Email) {
    return axios.post(`${CONTACTO_URL}/send`, data);
  },
};
